<template>
  <div class="icon-background" :style="{backgroundColor}">
    <svg class="center" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g transform="translate(-22 -146)">
        <path :style="{stroke:color}" class="a" d="M0,0V16" transform="translate(31 147)"/>
        <path :style="{stroke:color}" class="a" d="M0,0H16" transform="translate(23 155)"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AddIcon',
  props: {
    backgroundColor: String,
    color: String
  }
}
</script>

<style scoped>

.icon-background {
  background-color: #5AB88F;
  border-radius: 10%;
  width: 30px;
  height: 30px;
}

.center {
  margin: auto;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 80%;
}

svg .a {
   fill: none;
   stroke: #fff;
   stroke-linecap: round;
   stroke-width: 2px;
 }

</style>
